module.exports = __webpack_public_path__ + "img/1589739401.dd7b2fee.jpg";